import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "map-download-dropdown__list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_button_icon = _resolveComponent("c-button-icon")!
  const _component_c_dropdown = _resolveComponent("c-dropdown")!

  return (_openBlock(), _createBlock(_component_c_dropdown, {
    placement: _ctx.placement,
    "hide-animation": _ctx.hideAnimation,
    "shadow-root": _ctx.shadowRoot,
    onChangeVisibility: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dropdownTriggerActive = $event))
  }, {
    trigger: _withCtx(({ toggleVisibility }) => [
      _createVNode(_component_c_button_icon, {
        type: _ctx.buttonIconType,
        color: _ctx.buttonIconColor,
        "icon-name": _ctx.faDownload.iconName,
        "is-active": _ctx.dropdownTriggerActive,
        onClick: ($event: any) => (toggleVisibility())
      }, null, 8, ["type", "color", "icon-name", "is-active", "onClick"])
    ]),
    content: _withCtx(({ toggleVisibility }) => [
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", {
          onClick: ($event: any) => {
						_ctx.$emit(_ctx.ComponentEvent.DOWNLOAD_IMAGE);
						toggleVisibility();
					}
        }, _toDisplayString(_ctx.$t('options.download.image')), 9, _hoisted_2),
        _createElementVNode("li", {
          onClick: ($event: any) => {
						_ctx.$emit(_ctx.ComponentEvent.DOWNLOAD_PDF);
						toggleVisibility();
					}
        }, _toDisplayString(_ctx.$t('options.download.pdf')), 9, _hoisted_3),
        _createElementVNode("li", {
          onClick: ($event: any) => {
						_ctx.$emit(_ctx.ComponentEvent.DOWNLOAD_FILE);
						toggleVisibility();
					}
        }, _toDisplayString(_ctx.$t('options.download.file')), 9, _hoisted_4)
      ])
    ]),
    _: 1
  }, 8, ["placement", "hide-animation", "shadow-root"]))
}